const ORDER_ID_REGEX = /(?:^|[^\d])(\d{8,10})-(\d{4})-(\d{1,4})(?!\d)/;
const ORDER_ID_WITH_BARS_REGEX = /(?:^|[^\d])(\d{8,10})\|*-\|*(\d{4})\|*-\|*(\d{1,4})(?!\d)/;

export function extractLabelPageOrderId(pageText) {
  const chunks = pageText
    .split("|")
    .map((chunk) => chunk.trim())
    .filter(Boolean);

  // Prefer the chunk next to the suffix so digits in destination names are not
  // accidentally prepended to an 8-digit order number.
  for (let index = 0; index < chunks.length; index += 1) {
    const tailMatch = chunks[index].match(/^-(\d{4})-(\d{1,4})$/);
    if (!tailMatch) continue;

    let collectedDigits = "";
    for (let cursor = index - 1; cursor >= 0; cursor -= 1) {
      const onlyDigits = chunks[cursor].replace(/\D/g, "");
      if (!onlyDigits) {
        if (collectedDigits.length > 0) break;
        continue;
      }
      collectedDigits = onlyDigits + collectedDigits;
      if (collectedDigits.length >= 8 && collectedDigits.length <= 10) {
        return `${collectedDigits}-${tailMatch[1]}-${tailMatch[2]}`;
      }
      if (collectedDigits.length > 10) break;
    }
  }

  const normalizedPageText = pageText
    .replace(/[\u2010-\u2015\u2212]/g, "-")
    .replace(/[\s|]+/g, "");

  const withBarsMatch = normalizedPageText.match(ORDER_ID_WITH_BARS_REGEX);
  if (withBarsMatch) {
    return `${withBarsMatch[1]}-${withBarsMatch[2]}-${withBarsMatch[3]}`;
  }

  const noBarMatch = normalizedPageText.match(ORDER_ID_REGEX);
  if (noBarMatch) {
    return `${noBarMatch[1]}-${noBarMatch[2]}-${noBarMatch[3]}`;
  }

  return null;
}
